import actionCreator from '../../utils/actionCreator'

const PFX = 'USER'

export const turnOffRedirectUserToOrder = actionCreator(
  PFX,
  'turn_off_redirect_to_order'
)
